import 'floating-vue/dist/style.css'

import FloatingVue from 'floating-vue'
import Vue from 'vue'

Vue.use(FloatingVue, {
    themes: {
        'country-dropdown': {
            $extend: 'dropdown',
            autoSize: true,
        },
        'quantity-tooltip': {
            $extend: 'tooltip',
            placement: 'top',
        },
    },
})
